export const routeTicket = (id = ':id') => `/crm/${id}`;

export default () => '/crm';
